const { registerBlockType } = wp.blocks;

import Editor from "./Editor";
import Save from "./Save";

registerBlockType('email-form/block', {
  title: 'Formulário de email',
  description: 'Formulário de email com integração ao RD Station',
  icon: 'forms',
  category: 'widgets',
  attributes: {
    formId: {
      type: 'string'
    },
    buttonColor: {
			type: 'object',
			default: '#FFC430'
    },
    buttonTextColor: {
			type: 'object',
			default: '#001CBA'
    },
    buttonHoverColor: {
      type: 'object',
			default: '#FA8759'
    },
    buttonHoverTextColor: {
      type: 'object',
			default: '#001CBA'
    }
  },

  edit: props => <Editor {...props} />,
  save: props => <Save {...props} />
});
